import { Component, OnInit, Output, EventEmitter, Renderer2, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import templateString from './allocationRequestForm.component.html';
import * as moment from 'moment';
import { AllocationRequestPart } from '../../models/allocationRequestPart.model';
import { Candidate } from '../../models/candidate.model';
import { EnvironmentService } from '../../environment.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TimeSlot } from '../../models/timeSlot.model';
import { AllocationRequest } from '../../models/allocationRequest.model';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';

@Component({
  standalone: false,
  template: templateString
})
export class AllocationRequestFormComponent implements OnInit, AfterViewInit {
    @Output() action = new EventEmitter();

	public allocationRequestId;
	public selectedSchedulePeriod;
	public published_candidate_type_schedule_periods_contains_candidate_type_of_current_user: any;

	public allocationRequest;
	public activeDateStart;
	public activeDateEnd;
	public selectedSchedulePeriodStartDate;
	public selectedSchedulePeriodEndDate;
	public activeDate: any;
	public selectedDatesContainDateOutsideSchedulePeriod: boolean;
	public selectedDates: any;
	public periodicCandidateIds: any;
	public schedulePeriods: any;
	public shiftsForTaskType: any;
	public shiftsForTask: any;
	public allocationRequestTypes: any;
	public periodicCandidates: any;
	public periodicCandidate: any;
	public commonStatusId: any;
	public submitted: boolean;
	public allocationRequestForm: any;
	public user: any;
	public isNew: boolean;
	public allocationRequestShifts: {};
	public dateSelectionTypes: { id: number; title: string; }[];
	public allocationRequestStatuses: string[];
	public allocationRequestStatusButtonClasses: string[];
	public weekdays: { id: number; name: string; }[];
	public abbreviatedWeekdays: string[];
	public timeSlots: any;
	public actionTitle: string;
	public datePickerConfig: any;
	public datePickerConfigMultiSelect: any;
	public minDate;
	public maxDate;
	public displayDateStart: any;
	public displayDateEnd: any;
	public isLoading = false;
	public shiftsForPeriodicCandidate: any;
	public selectedShift: any;
	public candidateId: any;

	constructor(
		private renderer: Renderer2,
		private http: HttpClient,
		private environmentService: EnvironmentService,
		private bsModalRef: BsModalRef,
		private changeDetector: ChangeDetectorRef
	) {
		this.renderer.addClass(document.body, 'md-skin');
		this.renderer.addClass(document.body, 'landing-page');
		this.renderer.addClass(document.body, 'fixed-nav');
	}

	changeSelectedDates() {
		var self = this;
		this.candidateId = null;

		if (this.allocationRequest.allocation_request_type.is_time_registration) {
			this.candidateId = (this.user.isAdmin || this.user.isAllocationRequestAdmin) ? 
				(self.periodicCandidateIds.length > 0 && self.periodicCandidateIds[0] != null ? self.periodicCandidates.filter(function(x) { return self.periodicCandidateIds[0] == x.id; })[0].candidate_id : null) :
				this.periodicCandidate.candidate_id;

			if (this.candidateId) {
				forkJoin([
					self.http.get<any>("shifts/for_agenda", 
						{ 
							params: {
								candidate_id: this.candidateId, 
								start_date: self.selectedSchedulePeriod.start_date,
								end_date: self.selectedSchedulePeriod.end_date
							}
						}
					),
					self.http.get<any>("shifts/time_registration_shifts_for_schedule_period_by_candidate", 
						{ 
							params: {
								candidate_id: this.candidateId, 
								schedule_period_id: self.selectedSchedulePeriod.id
							}
						}
					),
				]).subscribe(data => {
					var shifts = data[0];
					var shiftsWithExistingAllocationRequest = data[1];
					var shiftsForPeriodicCandidate = [];

					shifts.forEach(function(shift) {
						if (moment(shift.start_date) <= moment().add(1, 'day') &&
							shiftsWithExistingAllocationRequest.filter(function(x) { return x.id == shift.id }).length == 0 &&
							moment(shift.start_date) >= moment(self.selectedSchedulePeriod.start_date) && moment(shift.start_date) < moment(self.selectedSchedulePeriod.end_date)) {
							shift.period = moment(shift.start_date).format('dd D MMM YYYY');
							if (!moment(shift.start_date).isSame(moment(shift.end_date).subtract(1, 'days'))) {
								shift.period += " t/m " + moment(shift.end_date).add(-1, 'days').format('dd D MMM YYYY');
							}
							shiftsForPeriodicCandidate.push(shift);
						}
					});

					self.shiftsForPeriodicCandidate = shiftsForPeriodicCandidate.sort(function(a, b) { return a.start_date > b.start_date ? 1 : -1 });;

					self.selectedShift = (self.allocationRequest.shift_id) ? self.shiftsForPeriodicCandidate.filter(function(x) { return x.id == self.allocationRequest.shift_id })[0] : null;
				});
			}

		} else if (this.allocationRequest.allocation_request_type.task_id != null && this.allocationRequest.allocation_request_type.is_allocate_preference) {

			// shift
			if (this.allocationRequest.shift_id == null) {
				this.allocationRequest.allocation_request_parts = [];
			} else {

				var shiftForTask = this.shiftsForTask[this.allocationRequest.allocation_request_type.task_id].filter(
					function(x) { return x.id == self.allocationRequest.shift_id; })[0];

				if (shiftForTask) { // dropdown with shifts could be empty
					if (this.allocationRequest.allocation_request_parts.length == 0) {
						this.allocationRequest.allocation_request_parts = [new AllocationRequestPart({
							is_allocate_preference: this.allocationRequest.allocation_request_type.is_allocate_preference,
							shift_id: shiftForTask.id,
							start_date: moment(shiftForTask.start_date).format("DD-MM-YYYY"),
							end_date: moment(shiftForTask.end_date).format("DD-MM-YYYY"),
							status_id: 2,
							formatted_end_date: moment(shiftForTask.end_date).subtract(1, 'day').format("DD-MM-YYYY"),
							openAllocationRequestPartCount: shiftForTask.open_allocation_request_part_count,
							acceptedAllocationRequestPartCount: shiftForTask.accepted_allocation_request_part_count,
							is_all_day: true
						})];
					} else {
						this.allocationRequest.allocation_request_parts[0].is_allocate_preference =
							this.allocationRequest.allocation_request_type.is_allocate_preference;
						this.allocationRequest.allocation_request_parts[0].shift_id = shiftForTask.id;
						this.allocationRequest.allocation_request_parts[0].start_date = moment(shiftForTask.start_date).format("DD-MM-YYYY");
						this.allocationRequest.allocation_request_parts[0].end_date = moment(shiftForTask.end_date).format("DD-MM-YYYY");
						this.allocationRequest.allocation_request_parts[0].formatted_end_date = moment(shiftForTask.end_date).subtract(1, 'day').format("DD-MM-YYYY");
						this.allocationRequest.allocation_request_parts[0].openAllocationRequestPartCount = shiftForTask.open_allocation_request_part_count;
						this.allocationRequest.allocation_request_parts[0].acceptedAllocationRequestPartCount = shiftForTask.accepted_allocation_request_part_count;
					}				
				}
			}

		} else if (this.allocationRequest.allocation_request_type.task_type_id != null &&
			this.allocationRequest.allocation_request_type.is_allocate_preference &&
				!this.allocationRequest.allocation_request_type.is_period_containing_tasks) {

			if (this.allocationRequest.shift_id == null) {
				this.allocationRequest.allocation_request_parts = [];
			} else {

				var shiftForTaskType = this.shiftsForTaskType[self.allocationRequest.allocation_request_type.task_type_id].filter(
					function(x) { return x.id == self.allocationRequest.shift_id; })[0];

				if (this.allocationRequest.allocation_request_parts.length == 0) {
					this.allocationRequest.allocation_request_parts = [new AllocationRequestPart({
						is_allocate_preference: this.allocationRequest.allocation_request_type.is_allocate_preference,
						shift_id: shiftForTaskType.id,
						task_type_id: this.allocationRequest.allocation_request_type.task_type_id,
						start_date: moment(shiftForTaskType.start_date).format("DD-MM-YYYY"),
						end_date: moment(shiftForTaskType.end_date).format("DD-MM-YYYY"),
						status_id: 2,
						formatted_end_date: moment(shiftForTaskType.end_date).subtract(1, 'day').format("DD-MM-YYYY"),
						openAllocationRequestPartCount: shiftForTaskType.open_allocation_request_part_count,
						acceptedAllocationRequestPartCount: shiftForTaskType.accepted_allocation_request_part_count,
						is_all_day: true
					})];
				} else if (!shiftForTaskType) {
					this.allocationRequest.shift_id = null;
					this.allocationRequest.allocation_request_parts = [];
				} else {
					this.allocationRequest.allocation_request_parts[0].is_allocate_preference =
						this.allocationRequest.allocation_request_type.is_allocate_preference;
					this.allocationRequest.allocation_request_parts[0].shift_id = shiftForTaskType.id;
					this.allocationRequest.allocation_request_parts[0].start_date = moment(shiftForTaskType.start_date).format("DD-MM-YYYY");
					this.allocationRequest.allocation_request_parts[0].end_date = moment(shiftForTaskType.end_date).format("DD-MM-YYYY");
					this.allocationRequest.allocation_request_parts[0].formatted_end_date = moment(shiftForTaskType.end_date).subtract(1, 'day').format("DD-MM-YYYY");
					this.allocationRequest.allocation_request_parts[0].openAllocationRequestPartCount = shiftForTaskType.open_allocation_request_part_count;
					this.allocationRequest.allocation_request_parts[0].acceptedAllocationRequestPartCount = shiftForTaskType.accepted_allocation_request_part_count;
				}
			}
		} else {
			if (this.allocationRequest.date_selection_type_id != 2) {
				this.allocationRequest.allocation_request_parts = [];
			}
			
			if (this.allocationRequest.start_date != null && this.allocationRequest.end_date != null) {
				if (this.allocationRequest.date_selection_type_id == 1) {

					var currentDate = this.activeDateStart.clone();
					var endDate = this.activeDateEnd.clone().add(1, 'day');
					
					if (this.allocationRequest.allocation_request_type.is_allocate_preference) {
						// is_allocate_preference is true

							var currentTaskTypeShifts = null;

						while (currentDate <= endDate) {
							// find task_type shift of which current date is in
							var matchedShiftsWithStartDateEqualToCurrentDate =
									this.shiftsForTaskType[this.allocationRequest.allocation_request_type.task_type_id].filter(
								function (x) { return currentDate.clone().format("DD-MM-YYYY") == moment(x.start_date).format("DD-MM-YYYY"); }
							);

							// task_type shift found
							if (matchedShiftsWithStartDateEqualToCurrentDate.length > 0) {

									if (currentTaskTypeShifts != null) {
										currentTaskTypeShifts.forEach(function(currentTaskTypeShift) {
											self.allocationRequest.allocation_request_parts.push(self.createAllocationRequestPartForShift(currentTaskTypeShift));
										});
									}

									// start taskTypeShift(s)
									currentTaskTypeShifts = this.getNonOverlappingShifts(matchedShiftsWithStartDateEqualToCurrentDate);
								} else {

									if (currentTaskTypeShifts == null) {
									// create request for each day, don't do it when we're at the last date
									if (currentDate.clone().isBefore(endDate.clone())) {
										this.allocationRequest.allocation_request_parts.push(
											new AllocationRequestPart({
												is_allocate_preference: false,
												start_date: currentDate.clone().format("DD-MM-YYYY"),
												end_date: currentDate.clone().add(1, 'day').format("DD-MM-YYYY"),
												status_id: 2,
												is_all_day: true
											})
										);
									}
									} else if (currentDate.clone().format("DD-MM-YYYY") == moment(currentTaskTypeShifts[0].end_date).format("DD-MM-YYYY")) {
										currentTaskTypeShifts.forEach(function(currentTaskTypeShift) {
											self.allocationRequest.allocation_request_parts.push(self.createAllocationRequestPartForShift(currentTaskTypeShift));
										});

										currentTaskTypeShifts = null;

									// Don't do this when we're at the last date
									if (currentDate.clone().isBefore(endDate.clone())) {

										this.allocationRequest.allocation_request_parts.push(
											new AllocationRequestPart({
												is_allocate_preference: false,
												// is_allocate_preference of allocation_request_type is true (for example for 'vakantie'), so this single
												// day should have is_allocate_preference=false because it's not linked to 'vakantie'
												task_type_id: null,
												start_date: currentDate.clone().format("DD-MM-YYYY"),
												end_date: currentDate.clone().add(1, 'day').format("DD-MM-YYYY"),
												status_id: 2,
												is_all_day: true
											})
										);
									}
								}
								
									if (currentDate.clone().isSame(endDate.clone()) && currentTaskTypeShifts)	 {

										var currentDate2 = moment(currentTaskTypeShifts[0].start_date);

									while (currentDate2.clone().isBefore(currentDate.clone())) {
										this.allocationRequest.allocation_request_parts.push(
											new AllocationRequestPart({
												is_allocate_preference: false,
												task_type_id: null,
												start_date: currentDate2.clone().format("DD-MM-YYYY"),
												end_date: currentDate2.clone().add(1, 'day').format("DD-MM-YYYY"),
												status_id: 2,
												is_all_day: true
											})
										);

										currentDate2 = currentDate2.clone().add(1, 'day');
									}
								}
							}

							currentDate = currentDate.add(1, 'day');
						}
					} else {
						// create single allocationRequestPart for 'geen dienst' (task_type) or 'geen verlengde dienst (task)
						this.allocationRequest.allocation_request_parts = [
							new AllocationRequestPart({
								is_allocate_preference: false,
								task_type_id: this.allocationRequest.allocation_request_type.task_type_id,
								start_date: currentDate.clone().format("DD-MM-YYYY"),
								end_date: endDate.clone().format("DD-MM-YYYY"),
								formatted_end_date: endDate.clone().subtract(1, 'day').format("DD-MM-YYYY"),
								status_id: 2,
								is_all_day: true
							})
						];
					}
				// losse dagen
				} else if (this.allocationRequest.date_selection_type_id == 2) {
					this.selectedDates = this.selectedDates.sort(function(a, b) { return (<any> moment(a)) - (<any> moment(b)); })

					var selectedDates = this.selectedDates.slice(0);

					for (var i = this.allocationRequest.allocation_request_parts.length - 1; i >= 0; i--) {

						var allocationRequestPart = this.allocationRequest.allocation_request_parts[i];

						var index = selectedDates.map(function(y) { return y.format("YYYYMMDD") }).indexOf(allocationRequestPart.start_date_for_order);

						if (index >= 0) {
							selectedDates.splice(index, 1);
						} else {
							this.allocationRequest.allocation_request_parts.splice(i, 1);
						}
					}

					selectedDates.forEach(function(x) {
						// find task_type shift of which current date is in
						var matchedShiftsWithStartDateEqualToCurrentDate =
							self.allocationRequest.allocation_request_type.task_type_id && self.shiftsForTaskType[self.allocationRequest.allocation_request_type.task_type_id] ? 
								self.shiftsForTaskType[self.allocationRequest.allocation_request_type.task_type_id].filter(
									function (y) { return x.clone().format("DD-MM-YYYY") == moment(y.start_date).format("DD-MM-YYYY") &&
										x.clone().add(1, 'day').format("DD-MM-YYYY") == moment(y.end_date).format("DD-MM-YYYY"); }) : 
								[];

							if (self.allocationRequest.allocation_request_type.is_allocate_preference) {
								var selectedDateTaskTypeShifts = self.getNonOverlappingShifts(matchedShiftsWithStartDateEqualToCurrentDate);

								if (selectedDateTaskTypeShifts.length > 0) {
									selectedDateTaskTypeShifts.forEach(function(currentTaskTypeShift) {
										var allocationRequestPart = self.createAllocationRequestPartForShift(currentTaskTypeShift);
										allocationRequestPart.start_date_for_order = x.clone().format("YYYYMMDD");
										allocationRequestPart.start_date_time = x;
										self.allocationRequest.allocation_request_parts.push(allocationRequestPart);
									});
								} else {
									self.allocationRequest.allocation_request_parts.push(new AllocationRequestPart({
										// if is_allocate_preference of allocation_request_type is true (for example for 'vakantie'), then this single
										// day should have is_allocate_preference=false because it's not linked to 'vakantie'
										is_allocate_preference: false,
										shift_id: null,
										task_type_id: null,
										start_date: x.clone().format("DD-MM-YYYY"),
										start_date_for_order: x.clone().format("YYYYMMDD"),
										start_date_time: x,
										end_date: x.clone().add(1, 'day').format("DD-MM-YYYY"),
										status_id: 2,
										is_all_day: true
									}));
								}
							} else {
								self.allocationRequest.allocation_request_parts.push(new AllocationRequestPart({
									is_allocate_preference: false,
									shift_id: null,
									task_type_id: self.allocationRequest.allocation_request_type.task_type_id,
									start_date: x.clone().format("DD-MM-YYYY"),
									start_date_for_order: x.clone().format("YYYYMMDD"),
									start_date_time: x,
									end_date: x.clone().add(1, 'day').format("DD-MM-YYYY"),
									status_id: 2,
									is_all_day: true
								}));
							}
					});

					this.selectedDatesContainDateOutsideSchedulePeriod = this.allocationRequest.allocation_request_parts.filter(function(x) { 
						return x.start_date_time.clone() < self.selectedSchedulePeriodStartDate || x.start_date_time.clone().add(1, 'day') > self.selectedSchedulePeriodEndDate 
					}).length > 0;

				// dag in de week
				} else if (this.allocationRequest.date_selection_type_id == 3) {

					if (this.allocationRequest.start_date != null && this.allocationRequest.end_date != null) {						
						var currentDate = this.activeDateStart.clone();
						var endDate = this.activeDateEnd.clone().add(1, 'day');

						while (currentDate < endDate) {

							// find task_type shift of which current date is in
							var matchedShiftsWithStartDateEqualToCurrentDate =
								self.allocationRequest.allocation_request_type.task_type_id && self.shiftsForTaskType[self.allocationRequest.allocation_request_type.task_type_id] ? 
									self.shiftsForTaskType[self.allocationRequest.allocation_request_type.task_type_id].filter(
										function (y) { return currentDate.clone().format("DD-MM-YYYY") == moment(y.start_date).format("DD-MM-YYYY") &&
											currentDate.clone().add(1, 'day').format("DD-MM-YYYY") == moment(y.end_date).format("DD-MM-YYYY"); }) : 
									[];

								if (currentDate.day() == this.allocationRequest.day_of_week) {
									if (self.allocationRequest.allocation_request_type.is_allocate_preference) {
										var currentDayTaskTypeShifts = self.getNonOverlappingShifts(matchedShiftsWithStartDateEqualToCurrentDate);

										if (currentDayTaskTypeShifts.length > 0) {
											currentDayTaskTypeShifts.forEach(function(currentTaskTypeShift) {
												var allocationRequestPart = self.createAllocationRequestPartForShift(currentTaskTypeShift);
												allocationRequestPart.start_date_for_order = currentDate.clone().format("YYYYMMDD");
												allocationRequestPart.start_date_time = currentDate;
												self.allocationRequest.allocation_request_parts.push(allocationRequestPart);
											});
										} else {
											self.allocationRequest.allocation_request_parts.push(new AllocationRequestPart({
												// if is_allocate_preference of allocation_request_type is true (for example for 'vakantie'), then this single
												// day should have is_allocate_preference=false because it's not linked to 'vakantie'
												is_allocate_preference: false,
												shift_id: null,
												task_type_id: null,
												start_date: currentDate.clone().format("DD-MM-YYYY"),
												start_date_for_order: currentDate.clone().format("YYYYMMDD"),
												start_date_time: currentDate,
												end_date: currentDate.clone().add(1, 'day').format("DD-MM-YYYY"),
												status_id: 2,
												is_all_day: true
											}));
										}
									} else {
										this.allocationRequest.allocation_request_parts.push(new AllocationRequestPart({
											is_allocate_preference: false,
											shift_id: null,
											task_type_id: self.allocationRequest.allocation_request_type.task_type_id,
											start_date: currentDate.clone().format("DD-MM-YYYY"),
											start_date_for_order: currentDate.clone().format("YYYYMMDD"),
											start_date_time: currentDate,
											end_date: currentDate.clone().add(1, 'day').format("DD-MM-YYYY"),
											status_id: 2,
											is_all_day: true
										}));
									}
								}

							currentDate = currentDate.add(1, 'day');
						}
					}
				}
			}
		}

		this.computeFormattedPeriods();

		this.resetCommonStatusId();
	}

	changeStartDate(changeSelectedDates) {
		if (!this.activeDateStart) {
			return;
		}
		this.allocationRequest.formattedStartDate = this.activeDateStart.clone().format("DD-MM-YYYY");

		if (this.activeDateStart >= this.activeDateEnd) {
			this.displayDateEnd = this.activeDateStart.clone();

			// this is a hack because changing displayDate and ngModel date at the same time will only change one of them...
			setTimeout(() => {
				this.activeDateEnd = this.activeDateStart.clone();
				this.changeEndDate(changeSelectedDates);
			}, 1000);
			
		} else if (changeSelectedDates) {
			this.changeSelectedDates();
		}
	}
	
	changeEndDate(changeSelectedDates) {
		if (this.activeDateEnd) {
			this.allocationRequest.formattedEndDate = this.activeDateEnd.clone().format("DD-MM-YYYY");
			if (changeSelectedDates) {
				this.changeSelectedDates();			
			}
		}
	}
	
	initializePeriod() {
		this.activeDateStart = moment(this.allocationRequest.start_date);
		this.activeDateEnd = moment(this.allocationRequest.end_date).subtract(1, 'day');
		
		this.displayDateStart = this.activeDateStart;
		this.displayDateEnd = this.activeDateEnd;

		this.changeStartDate(false);
		this.changeEndDate(false);
	}

  	resetDateSelection() {
		this.selectedDatesContainDateOutsideSchedulePeriod = false;
		
		this.allocationRequest.allocation_request_parts = [];

		var initStartDate;
		var today = moment();
		
		if ((today.isSame(this.selectedSchedulePeriodStartDate.clone()) || today.isAfter(this.selectedSchedulePeriodStartDate.clone())) && today.isBefore(this.selectedSchedulePeriodEndDate)) {
			// TODO only use moment
			initStartDate = moment(new Date(today.year(), today.month(), today.date()));
		} else {
			initStartDate = moment(new Date(this.selectedSchedulePeriodStartDate.year(), this.selectedSchedulePeriodStartDate.month(), this.selectedSchedulePeriodStartDate.date())); 
		}

		var initStartDatePlusOne = initStartDate.clone().add(1, 'day');
		var initEndDate = moment(new Date(initStartDatePlusOne.year(), initStartDatePlusOne.month(), initStartDatePlusOne.date()));

		this.selectedDates.splice(0, this.selectedDates.length);
		this.activeDate = initStartDate;
		
		this.allocationRequest.start_date = initStartDate;
		this.allocationRequest.end_date = initEndDate;
		
		this.initializePeriod();
  	}
	
	resetDatePickerOptions(schedulePeriod) {
		this.datePickerConfig = {
			firstDayOfWeek: "mo"
		}

		this.datePickerConfigMultiSelect = {
			firstDayOfWeek: "mo",
			allowMultiSelect: true
		}
	}

	deletePeriodicCandidateId(index) {
		this.periodicCandidateIds.splice(index, 1);;
	}
	
	addPeriodicCandidateId() {
		this.periodicCandidateIds.push(null);
	}

	changeSchedulePeriod(resetFields) {
		var self = this;

		if (resetFields) {
			this.allocationRequest.allocation_request_type_id = null;
			this.allocationRequest.date_selection_type_id = null;
			for(var i = 0; i < this.periodicCandidateIds.length; i++) {
				this.periodicCandidateIds[i] = null;
			}
		}

		this.selectedSchedulePeriod = this.schedulePeriods.filter(function(x) { return x.id == self.allocationRequest.schedule_period_id; })[0];
		this.selectedSchedulePeriodStartDate = moment(this.selectedSchedulePeriod.start_date);
		this.selectedSchedulePeriodEndDate = moment(this.selectedSchedulePeriod.end_date);
		
		this.minDate = moment(this.selectedSchedulePeriod.start_date);
		this.maxDate = moment(this.selectedSchedulePeriod.end_date).subtract(1, 'day');

		this.resetDatePickerOptions(this.selectedSchedulePeriod);
		
		this.http.get("allocation_request_types",
			{ 
				params: {
					schedule_period_id: this.allocationRequest.schedule_period_id 
				}
			}
		).subscribe(x => {

			this.allocationRequestTypes = x;
		
			this.allocationRequestTypes.filter(function(y) { return y.is_allocate_preference }).forEach(function(y) {
				if (y.task_id != null) {
					self.http.get<any>("shifts/with_task", 
						{ 
							params: {
								task_id: y.task_id, 
								allocation_request_id: self.allocationRequest.id,
								only_allocate_open_shifts: y.only_allocate_open_shifts 	
							}
						}
					).subscribe(shifts => {
						var shiftsForTask = shifts;

						shiftsForTask.forEach(function(shift) {
							shift.period = moment(shift.start_date).format('dd D MMM YYYY');
							if (!moment(shift.start_date).isSame(moment(shift.end_date).subtract(1, 'days'))) {
								shift.period += " t/m " + moment(shift.end_date).add(-1, 'days').format('dd D MMM YYYY');
							}
						});
		
						self.shiftsForTask[y.task_id] = shiftsForTask;
					});
				} else if (y.task_type_id != null) {
					self.http.get<any>("shifts/with_task_type", 
						{ 
								params: {
									task_type_id: y.task_type_id,
									schedule_period_id: self.allocationRequest.schedule_period_id,
									allocation_request_id: self.allocationRequest.id,
									only_allocate_open_shifts: y.only_allocate_open_shifts,
									is_period_containing_tasks: y.is_period_containing_tasks
								}
							}
						).subscribe(shifts => {
						var shiftsForTaskType = shifts;
						shiftsForTaskType.forEach(function(shift) {
							shift.period = moment(shift.start_date).format('dd D MMM YYYY');
							if (!moment(shift.start_date).isSame(moment(shift.end_date).subtract(1, 'days'))) {
								shift.period += " t/m " + moment(shift.end_date).add(-1, 'days').format('dd D MMM YYYY');
							}
						});

						self.shiftsForTaskType[y.task_type_id] = shiftsForTaskType;
					});
				}
			});
		
			this.changeAllocationRequestType(resetFields);
		});
		
		this.http.get("periodic_candidates/index_alphabetically", 
			{ 
				params: {
					schedule_period_id: this.allocationRequest.schedule_period_id
				}
			}
		).subscribe(periodicCandidates => {
			this.periodicCandidates = periodicCandidates;
			
			this.periodicCandidates.forEach(function(periodicCandidate) {
				periodicCandidate.lastnameWithInfix = (new Candidate(periodicCandidate.candidate)).lastnameWithInfix();
			});
			
			this.periodicCandidate = this.periodicCandidates.filter(function(x) { return x.candidate_id == self.user.candidateId; })[0];
		});
	}
	
	changeAllocationRequestType(resetFields) {
		var self = this;
		if (this.allocationRequest.allocation_request_type_id == null) {
			this.allocationRequest.allocation_request_type = null;
		} else {
			this.allocationRequest.allocation_request_type = this.allocationRequestTypes.filter(function(x) { return x.id == self.allocationRequest.allocation_request_type_id })[0];
		}

		if (resetFields) {
			this.changeDateSelectionType();
		}
	}
	
	changeDateSelectionType() {
		this.resetDateSelection();
		if (this.allocationRequest.allocation_request_type != null) {
			this.changeSelectedDates();
		}
	}

  	removeFromSelectedDates(date) {
    	this.selectedDates.splice(this.selectedDates.indexOf(date), 1);
		this.changeSelectedDates();
  	}
	
  	resetCommonStatusId() {
		this.commonStatusId = undefined;
		
		if (this.allocationRequest.allocation_request_parts.length > 0) {
			var uniqueStatusId = this.allocationRequest.allocation_request_parts[0].status_id;
			
			if (this.allocationRequest.allocation_request_parts.filter(function(x) { return x.status_id != uniqueStatusId; }).length == 0) {
				this.commonStatusId = uniqueStatusId;
			}
		}
	}

	computeFormattedPeriods() {
		var self = this;
		this.allocationRequest.allocation_request_parts.forEach(function(x) {
			x.formattedPeriod = self.formatDate(x.start_date);
			
			if (x.formatted_end_date != null && x.start_date != x.formatted_end_date) {
				x.formattedPeriod += " t/m " + self.formatDate(x.formatted_end_date);
			}
		});
	}

	showAllocationRequestPartDayPartControls(allocationRequestPart) {
		return this.user.customer.customer_type_id == 4 &&
			!this.allocationRequest.allocation_request_type.is_time_registration &&
			!this.isAllocationRequestPartSingleDayPartShift(allocationRequestPart);
	}

	canRemoveAllocationRequestPart(allocationRequestPart) {
		if (this.isAllocationRequestPartSingleDayPartShift(allocationRequestPart)) {
			return true;
		}

		return this.allocationRequest.date_selection_type_id == 3 &&
			!(
				this.allocationRequest.allocation_request_type.is_allocate_preference &&
				this.allocationRequest.allocation_request_type.is_period_containing_tasks
			);
	}

	isAllocationRequestPartSingleDayPartShift(allocationRequestPart) {
		var shift = allocationRequestPart.shift || null;

		return (
			this.allocationRequest.allocation_request_type.is_allocate_preference &&
			this.allocationRequest.allocation_request_type.is_period_containing_tasks &&
			allocationRequestPart.is_allocate_preference &&
			allocationRequestPart.shift_id &&
			(
				allocationRequestPart.shiftTimeLabel && allocationRequestPart.shiftTimeLabel != "Hele dag" ||
				shift && shift.shift_days && shift.shift_days.length == 1 &&
					!shift.shift_days[0].is_all_day &&
					shift.shift_days[0].start_time &&
					shift.shift_days[0].end_time
			)
		);
	}

	formatDate(date) {
		return this.abbreviatedWeekdays[moment(date, "DD-MM-YYYY").day()] + " " + date;
	}

	getNonOverlappingShifts(shifts) {
		var self = this;
		var nonOverlappingShifts = [];

		shifts.forEach(function(shift) {
			if (nonOverlappingShifts.filter(function(x) { return self.shiftsOverlap(x, shift); }).length == 0) {
				nonOverlappingShifts.push(shift);
			}
		});

		return nonOverlappingShifts;
	}

	shiftsOverlap(firstShift, secondShift) {
		var self = this;

		if (!firstShift.shift_days || !secondShift.shift_days) {
			return true;
		}

		return firstShift.shift_days.filter(function(firstShiftDay) {
			return secondShift.shift_days.filter(function(secondShiftDay) {
				return self.shiftDaysOverlap(firstShiftDay, secondShiftDay);
			}).length > 0;
		}).length > 0;
	}

	shiftDaysOverlap(firstShiftDay, secondShiftDay) {
		if (firstShiftDay.date != secondShiftDay.date) {
			return false;
		}

		if (firstShiftDay.is_all_day || secondShiftDay.is_all_day || !firstShiftDay.start_time || !firstShiftDay.end_time || !secondShiftDay.start_time || !secondShiftDay.end_time) {
			return true;
		}

		var firstStartTime = moment(firstShiftDay.start_time);
		var firstEndTime = moment(firstShiftDay.end_time);
		var secondStartTime = moment(secondShiftDay.start_time);
		var secondEndTime = moment(secondShiftDay.end_time);

		if (firstEndTime <= firstStartTime) {
			firstEndTime = firstEndTime.add(1, 'day');
		}

		if (secondEndTime <= secondStartTime) {
			secondEndTime = secondEndTime.add(1, 'day');
		}

		return firstStartTime < secondEndTime && firstEndTime > secondStartTime;
	}

	createAllocationRequestPartForShift(shift) {
		return new AllocationRequestPart({
			is_allocate_preference: true,
			shift_id: shift.id,
			task_type_id: this.allocationRequest.allocation_request_type.task_type_id,
			start_date: moment(shift.start_date).format("DD-MM-YYYY"),
			end_date: moment(shift.end_date).format("DD-MM-YYYY"),
			formatted_end_date: moment(shift.end_date).subtract(1, 'day').format("DD-MM-YYYY"),
			status_id: 2,
			openAllocationRequestPartCount: shift.open_allocation_request_part_count,
			acceptedAllocationRequestPartCount: shift.accepted_allocation_request_part_count,
			shiftDisplayName: shift.task ? shift.task.name : null,
			shiftTimeLabel: this.getShiftTimeLabel(shift),
			is_all_day: true
		});
	}

	getShiftTimeLabel(shift) {
		if (!shift.shift_days || shift.shift_days.length == 0) {
			return null;
		}

		var shiftDay = shift.shift_days[0];

		if (shiftDay.is_all_day || !shiftDay.start_time || !shiftDay.end_time) {
			return "Hele dag";
		}

		return moment(shiftDay.start_time).format("HH:mm") + " - " + moment(shiftDay.end_time).format("HH:mm");
	}

	getAllocationRequestPartShiftDescription(allocationRequestPart) {
		var shiftDisplayName = allocationRequestPart.shiftDisplayName || (allocationRequestPart.shift && allocationRequestPart.shift.task ? allocationRequestPart.shift.task.name : null);
		var shiftTimeLabel = allocationRequestPart.shiftTimeLabel || (allocationRequestPart.shift ? this.getShiftTimeLabel(allocationRequestPart.shift) : null);

		return [shiftDisplayName, shiftTimeLabel].filter(function(x) { return x; }).join(" | ");
	}

	getAllocationRequestPartType(allocationRequestPart) {
		if (this.allocationRequest.allocation_request_type.task_type_id != null && allocationRequestPart.is_allocate_preference) {
			return this.allocationRequest.allocation_request_type.task_type.name;
		} else {
			return this.allocationRequest.allocation_request_type.name;
		}
	}
	
  	setAllocationRequestStatus(allocationRequestStatusId) {
    	this.allocationRequest.status_id = allocationRequestStatusId;
  	}
	
	setAllocationRequestPartStatus(allocationRequestPart, statusId) {
		this.allocationRequest.allocation_request_parts.filter(function(x) { return x.start_date == allocationRequestPart.start_date })[0].status_id = statusId;
		
		this.resetCommonStatusId();
	}
	
	setAllAllocationRequestPartStatuses(statusId) {
		this.allocationRequest.allocation_request_parts.forEach(function(x) { 
			x.status_id = statusId;
		});
		
		this.resetCommonStatusId();
	}

	setAllocationRequestPartIsAllDay(allocationRequestPart) {
		allocationRequestPart.time_slot_id = null;
	}

	removeAllocationRequestPart(index) {
		this.allocationRequest.allocation_request_parts.splice(index, 1);
	}

  	ok(isValid) {
		// // Don't use isValid as a parameter here, because we want to make some changes to the validation results first:
		// // Because of the min and max dates added in datepickerOptions and we use today as the default filled in date for the datepickers, 
		// // the datepickers that are not used (thus hidden) could have an invalid date, which causes the form.$valid to be false
		// // The following alternatives are possible:
		// // - use *ngIf instead of [hidden], then validation will not occur -> datepickers are not reinitialized correctly and stop working when they become visible again [NOT CHOSEN]
		// // - initialize not with today date, but with first date in schedule period -> then we need to reinitialize the init-date of the datepickers when another scheduleperiod is selected [NOT CHOSEN]
		// // - manually set the particular validation to true for all the datepicker fields [CHOSEN]
		// this.allocationRequestForm.activeDateStart.$setValidity('dateDisabled', true);
		// this.allocationRequestForm.activeDateEnd.$setValidity('dateDisabled', true);
		// this.allocationRequestForm.activeDate.$setValidity('dateDisabled', true);				
		
		this.submitted = true;

		if ((this.user.isAdmin || this.user.isAllocationRequestAdmin || this.periodicCandidate != null) && isValid && 
			(this.allocationRequestId != null || !(this.user.isAdmin && !this.user.isAllocationRequestAdmin) || this.periodicCandidateIds.length > 0) &&
			(
				(this.allocationRequest.allocation_request_type.task_id != null && this.allocationRequest.shift_id != null && this.allocationRequest.shift_id != '') ||
				(this.allocationRequest.allocation_request_type.is_allocate_preference && 
					!this.allocationRequest.allocation_request_type.is_period_containing_tasks && 
					this.allocationRequest.shift_id != null && this.allocationRequest.shift_id != '') ||
				(
					(
						(
							this.allocationRequest.allocation_request_type.task_id == null || 
							!this.allocationRequest.allocation_request_type.is_allocate_preference
						) && 
						this.allocationRequest.date_selection_type_id != null
					) && 
					(
						(
							(this.allocationRequest.date_selection_type_id == 1 || this.allocationRequest.date_selection_type_id == 3) && 
								(
									this.activeDateStart <= this.activeDateEnd &&
									this.activeDateStart >= this.selectedSchedulePeriodStartDate &&
									this.activeDateEnd < this.selectedSchedulePeriodEndDate // use < because activeDateEnd is the day before the actual end date
								)
						) &&
						(this.allocationRequest.date_selection_type_id != 3 || this.allocationRequest.day_of_week != null) &&
						(this.allocationRequest.allocation_request_parts.length > 0)
					) ||
					(
						this.allocationRequest.date_selection_type_id == 2 && 
							(
								this.allocationRequest.allocation_request_parts.length > 0 &&
								!this.selectedDatesContainDateOutsideSchedulePeriod
							)
					)
				) ||
				(this.allocationRequest.allocation_request_type.is_time_registration &&
					(this.allocationRequestId != null || (this.selectedShift.shift_days[0].start_time && this.selectedShift.shift_days[0].end_time)))
			)
		) {
			this.isLoading = true;

			if (this.allocationRequestId == null) {
				if (this.allocationRequest.allocation_request_type.is_time_registration) {
					this.allocationRequest.overwritten_start_time = this.selectedShift.shift_days[0].start_time;
					this.allocationRequest.overwritten_end_time = this.selectedShift.shift_days[0].end_time;
				}

				if (this.user.isAdmin || this.user.isAllocationRequestAdmin) {
					this.allocationRequest.periodic_candidate_ids = this.periodicCandidateIds;
				} else {
					this.allocationRequest.periodic_candidate_ids = [this.periodicCandidate.id]
				}

				if (this.selectedSchedulePeriod.id != this.environmentService.getSchedulePeriodSelection().id) {
					// change globally selected schedule period
					this.environmentService.setSchedulePeriodSelectionExternally(this.selectedSchedulePeriod);
				}

				this.http.post('allocation_requests',
					{ allocation_request: this.allocationRequest }
				).subscribe(result => {
					var changedShifts = JSON.parse(result['changed']);
					
					if (changedShifts.length > 0){
						window.alert("De volgende activiteiten zijn automatisch toegewezen door het accepteren van de betreffende verzoeksonderdelen: " + 
							changedShifts.map(function(x) { return "\n- " + x.task.name + " (" + moment(x.start_date).format("DD-MM-YYYY") + ") toegewezen aan " + (new Candidate(x.periodic_candidate.candidate)).infixWithLastname() }))
					}

					this.action.emit();
					this.bsModalRef.hide();
				});
			} else {
				this.http.put("allocation_requests/" + this.allocationRequest.id, { allocation_request: this.allocationRequest }).subscribe((result) => {
					var changedShifts = JSON.parse(result['changed']);
					
					if (changedShifts.length > 0){
						window.alert("De volgende activiteiten zijn automatisch toegewezen door het accepteren van de betreffende verzoeksonderdelen: " + 
							changedShifts.map(function(x) { return "\n- " + x.task.name + " (" + moment(x.start_date).format("DD-MM-YYYY") + ") toegewezen aan " + (new Candidate(x.periodic_candidate.candidate)).infixWithLastname() }))
					}
					
					this.action.emit();
					this.bsModalRef.hide();
				});
			}			
		}		
  	};

  	cancel() {
    	this.bsModalRef.hide();
	};
	  
	trackByFunction(index) {
		return index;
	}

	ngOnInit() {		
		this.isNew = this.allocationRequestId == null;

		this.user = this.environmentService.getUser();
	
		this.allocationRequestShifts = {};
		this.commonStatusId = undefined;
		this.shiftsForTask = {};
		this.shiftsForTaskType = {};
		this.shiftsForPeriodicCandidate = [];
		this.selectedDates = [];
		this.selectedDatesContainDateOutsideSchedulePeriod = false;
		
		this.periodicCandidateIds = [null];
		
		 this.dateSelectionTypes = [
			{ id: 1, title: "Periode" }, 
			{ id: 2, title: "Losse dagen" },
			{ id: 3, title: "Vaste dag in de week" }
		];
		
		this.allocationRequestStatuses = ["Geweigerd", "Niet verwerkt", "Geaccepteerd"];
		this.allocationRequestStatusButtonClasses = ["btn-danger", "btn-warning", "btn-primary"];
	
		this.resetDatePickerOptions(this.selectedSchedulePeriod);

		var weekdays = ["maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag", "zondag"];
		this.weekdays = weekdays.map(function(x, index) { return { id: index + 1, name: x }; });
		this.abbreviatedWeekdays = ["zo", "ma", "di", "wo", "do", "vr", "za"];
	
		// initialize date pickers TODO DRY -> this should be here (not within promise) otherwise it takes too long to fill activeDateStart and -end
		// and bootstrap datepicker gives error when initializing
		var now = new Date();
		var today = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate()));
		this.activeDateStart = today;
		this.activeDateEnd = today;
		this.selectedDates.splice(0, this.selectedDates.length);
		this.activeDate = today;
	
		this.http.get("time_slots").subscribe(x => {
			this.timeSlots = x;
			
			this.timeSlots.forEach(function(timeSlot) {
				timeSlot.nameWithTime = (new TimeSlot(timeSlot)).nameWithTime();
			});
		});
	
		this.http.get("schedule_periods").subscribe(schedulePeriods => {
			this.schedulePeriods = schedulePeriods;
			
			this.schedulePeriods.forEach(function(schedulePeriod) {
				schedulePeriod.nameWithPeriod = schedulePeriod.name + " (" + moment(schedulePeriod.start_date).format("D MMM YYYY") + " - " + moment(schedulePeriod.end_date).subtract(1, 'day').format("D MMM YYYY") + ")";
			});
			
			if (this.allocationRequestId == null) {
				this.actionTitle = "toevoegen";
				this.allocationRequest = new AllocationRequest();
				this.allocationRequest.allocation_request_parts = []
	
				if (this.selectedSchedulePeriod == null) {
					this.schedulePeriods.forEach(function(schedulePeriod) {
						if (schedulePeriod.is_default) {
							this.allocationRequest.schedule_period_id = schedulePeriod.id;
						}
					});
				} else {
					this.allocationRequest.schedule_period_id = this.selectedSchedulePeriod.id;
				}
			
				this.changeSchedulePeriod(false);
				this.resetDateSelection();
			} else {
				
				this.http.get("allocation_requests/" + this.allocationRequestId).subscribe(x => {
					this.allocationRequest = x;
	
					if ((this.allocationRequest.allocation_request_type.task_id != null && this.allocationRequest.allocation_request_type.is_allocate_preference) ||
							(
								this.allocationRequest.allocation_request_type.task_type_id != null && 
								this.allocationRequest.allocation_request_type.is_allocate_preference &&
								!this.allocationRequest.allocation_request_type.is_period_containing_tasks
							)
					) {
						this.allocationRequest.shift_id = this.allocationRequest.allocation_request_parts[0].shift_id;
						
						this.allocationRequest.allocation_request_parts[0].start_date = moment(this.allocationRequest.allocation_request_parts[0].start_date).format("DD-MM-YYYY");
						var endDate = this.allocationRequest.allocation_request_parts[0].end_date;
						this.allocationRequest.allocation_request_parts[0].end_date = endDate.clone().format("DD-MM-YYYY");
						this.allocationRequest.allocation_request_parts[0].formatted_end_date = endDate.clone().subtract(1, 'day').format("DD-MM-YYYY");
						this.allocationRequest.allocation_request_parts[0].openAllocationRequestPartCount = this.allocationRequest.allocation_request_parts[0].open_allocation_request_part_count;
						this.allocationRequest.allocation_request_parts[0].acceptedAllocationRequestPartCount = this.allocationRequest.allocation_request_parts[0].accepted_allocation_request_part_count;
						
					} else if (this.allocationRequest.date_selection_type_id == 2) {
						//this.selectedDates = this.allocationRequest.allocation_request_parts.map(function(y) { return new Date(y.start_date).getTime() - 7200000 });
						this.selectedDates = this.allocationRequest.allocation_request_parts.map(function(y) { return moment(y.start_date) });

						this.activeDate = moment(new Date(this.allocationRequest.allocation_request_parts[0].start_date));

						this.displayDateStart = this.activeDate;

						this.allocationRequest.allocation_request_parts.forEach(function(y) {
							y.start_date_time = moment(new Date(y.start_date).getTime() - 7200000);
							y.start_date_for_order = moment(y.start_date).format("YYYYMMDD");
							y.start_date = moment(y.start_date).format("DD-MM-YYYY");
							y.end_date = moment(y.end_date).format("DD-MM-YYYY");
						});
					} else if (this.allocationRequest.date_selection_type_id == 1 || this.allocationRequest.date_selection_type_id == 3) {
	
						this.initializePeriod();
	
						this.allocationRequest.allocation_request_parts.forEach(function(y) {
							var endDate = moment(y.end_date);
	
							y.start_date_time = moment(new Date(y.start_date).getTime() - 7200000);
							y.start_date_for_order = moment(y.start_date).format("YYYYMMDD");
							y.start_date = moment(y.start_date).format("DD-MM-YYYY");
							y.end_date = endDate.clone().format("DD-MM-YYYY");
							y.formatted_end_date = endDate.clone().subtract(1, 'day').format("DD-MM-YYYY");
							y.openAllocationRequestPartCount = y.open_allocation_request_part_count;
							y.acceptedAllocationRequestPartCount = y.accepted_allocation_request_part_count;
						});
					
						if (this.allocationRequest.date_selection_type_id == 3) {
							this.resetCommonStatusId();
						}
					}
	
					this.changeSchedulePeriod(false);
					this.computeFormattedPeriods();
				});
			
				this.actionTitle = "wijzigen";
			}		
		});	
	}

	ngAfterViewInit() {
		// Stabilize bindings for the datepicker which can update ngModel during init.
		this.changeDetector.detectChanges();
	}
}
